@if (isLayoutVisible) {
  <div class="wrapper">
    <div class="sidebar" data-color="white" data-active-color="danger">
      <sidebar-cmp></sidebar-cmp>
    </div>
    <div class="main-panel">
      <tded-header class="common-grid-size"></tded-header>
      <div class="content">
        <!-- <app-breadcrumb></app-breadcrumb> -->
        <router-outlet></router-outlet>
      </div>
      <tded-footer class="common-grid-size"></tded-footer>
    </div>
  </div>
}

@if (!isLayoutVisible) {
  <div class="wrapper">
    <router-outlet></router-outlet>
  </div>
}